import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const darkMachineQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-wishlist-added",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Game Trailer",
    caption: "Engage with the gameplay",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/dark-machine/DarkMachineTrailer.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-trailer-1-watched",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-trailer-1",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Anime Trailer",
    caption: "Dive into the Dark Machine universe",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/dark-machine/DarkMachineAnimeTrailer.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-trailer-2-watched",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-trailer-2",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @DarkMachineGame on X",
    caption: "Stay updated with the latest news",
    linkUrl: "https://x.com/DarkMachineGame",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-twitter-followed",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/darkmachine",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-discord-followed",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-discord",
  },
  {
    type: "link",
    key: "telegram",
    icon: "ApplicationWeb",
    label: "Join TG Announcement Channel",
    caption: "Stay updated with announcements",
    linkUrl: "https://t.me/DarkMachineAnnounce",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-telegram-1-joined",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-telegram-1",
  },
  {
    type: "link",
    key: "telegram",
    icon: "ApplicationWeb",
    label: "Join TG group and Generate 4,000 PXTL points",
    caption: "Earn points in the community",
    linkUrl: "https://t.me/DarkMachineCompBot",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-telegram-2-points",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-telegram-2",
  },
  {
    type: "custom",
    key: "bonus-variant-2",
    icon: "TreasureChest",
    label: "Discover if you won",
    caption: "Winners announced",
    increase: 0,
    badgeIcon: "TreasureChest",
    badgeTemplate: "Win an exclusive NFT <icon>",
    eventId: "this-will-never-be-completed",
    ruleId: "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c-onboarding",
  },
];

export const darkMachineQuests: QuestGroup[] = [
  {
    key: "level-0",
    progressIcon: "TreasureChest",
    progressTemplate: "(Ended) Win an NFT worth 0.25 ETH* <icon>",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 40,
    quests: darkMachineQuestsList,
  },
];
